module.exports = __webpack_public_path__ + "static/media/11NEPAD2.b61948c3.jpg";